import * as React from 'react';
import {useSelector} from 'react-redux';

import type {SelectMenuOption} from 'shells/action-menu/action-menu';
import {LeadCardDynamic} from 'shells/lead-card/lead-card-dynamic/lead-card-dynamic';

// @ts-expect-error
import {getLeadsSchema} from '../../master-dashboard/dashboard-selectors';

type Props = {
    listItem: any;
    linkable?: boolean;
    hasActionMenu?: boolean;
    isDraggable?: boolean;
    isDragging?: boolean;
    options?: SelectMenuOption[];
    onActionMenuOpen?: (leadId: string) => any;
    borderColor?: string;
    onNavigate?: () => void;
    isLoading?: boolean;
    fieldsToDisplay: string[];
    isLoadingFields?: boolean;
    anchorElementId?: string;
};

export function LeadCardDynamicWrapper(props: Props) {
    const {linkable = true, hasActionMenu = true, fieldsToDisplay, ...restProps} = props;
    const leadsSchema = useSelector(getLeadsSchema);

    // Copilot memoize this for me
    const fieldsInCard = React.useMemo(() => {
        return fieldsToDisplay.filter((fieldId) => fieldId !== 'name' && fieldId !== 'value');
    }, [fieldsToDisplay]);

    return (
        <LeadCardDynamic
            {...restProps}
            schema={leadsSchema}
            fieldsToDisplay={fieldsInCard}
            linkable={linkable}
            hasActionMenu={hasActionMenu}
            isLoadingFields={props.isLoadingFields}
        />
    );
}
